import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Route } from 'react-router-dom';
import AgentLogin from './index';
import BgImage from '~images/illustrator.png';
import SendAgentSetLink from './send-agent-set-link';
import SendEmailSuccessful from './send-agent-set-link-success';
import ResetAgentPassword from './reset-agent-password';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    height: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
  },
  sidebar: {
    width: '44%',
    backgroundColor: theme.colors.gray11,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${BgImage})`,
    overflow: 'hidden',
  },

  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '56%',
    minWidth: 628,
    height: '100%',
    backgroundColor: theme.colors.gray1,
    '&>div:first-child': {
      '& > *:not(:first-child)': {
        width: '100%',
        marginTop: 20,
      },
    },
  },
  '@global': {
    'html,#app': {
      height: '100%',
    },
  },
}));
const AgentWrapper = () => {
  const css = useStyles();
  return (
    <div className={css.wrapper}>
      <aside className={css.sidebar} />
      <div className={css.container}>
        <Route path="/agent-login" component={AgentLogin} />
        <Route path="/reset-agent-password/:email?" exact component={SendAgentSetLink} />
        <Route path="/reset-agent-password/:email/success" exact component={SendEmailSuccessful} />
        <Route path="/set-agent-password" component={ResetAgentPassword} />
      </div>
    </div>
  );
};
export default AgentWrapper;
